<template>

    <div style="max-height:72vh;" class="border border-gray-300 mb-12 overflow-x-scroll">
        <table class="table relative">
            <thead>
                <tr>
                    <th class="sticky z-20" style="top: -1px;">Day</th>
                    <th class="sticky z-20" style="top: -1px;">Date</th>
                    <th class="sticky z-20" style="top: -1px; width: 8rem">Absence</th>
                    <th class="sticky z-20" style="top: -1px;">From</th>
                    <th class="sticky z-20" style="top: -1px;">To</th>
                    <th class="sticky z-20" style="top: -1px;">Overtime</th>
                    <th class="sticky z-20" style="top: -1px;">Hours</th>
                </tr>
            </thead>
            <tbody v-if="marktime">
                <tr
                    v-for="(day, index) in marktime.marktime"
                    :key="index"
                    :class="setClass(index)">
                    <td>{{ getDate(index, 'dd') }}</td>
                    <td>{{ getDate(index, 'DD.MM.YYYY') }}</td>
                    <td>
                        <div class="flex items-center">
                            <select style="width:50px" class="form-input form-input-small" v-model="marktime.marktime[index].type" @change="setReason($event, index)">
                                <option value="0">-</option>
                                <option v-for="reason in getReasons(index)" :key="reason.id" :value="reason.id">{{ reason.id }}</option>
                            </select>

                            <div v-if="marktime.marktime[index].type === 'NV'" class="ml-2 tooltip">
                                <select class="form-input form-input-small px-3" v-model="marktime.marktime[index].timeOff" @change="setTimeOff($event, index)">
                                    <option v-for="index in timeOffHoursSelect" :key="index" :value="index">{{ index }}</option>
                                </select>
                                <span class="tooltip-text -mt-6 -ml-16">Time off in lieu hours</span>
                            </div>
        
                            <div v-if="marktime.marktime[index].type === 'D'" class="ml-2 tooltip">
                                <input type="checkbox" v-model="marktime.marktime[index].halfday" @change="setHalfDay(index)">
                                <span class="tooltip-text -mt-6 -ml-8">Half-day</span>
                            </div>
                            <div v-if="isHoliday(index) || isSaturday(index) || isSunday(index)" class="ml-2 tooltip">
                                <input type="checkbox" v-model="marktime.marktime[index].specialHours" @change="setSpecialHours(index)">
                                <span class="tooltip-text -mt-6 -ml-8">Work hours</span>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div v-if="day.timeFrom">
                            <select class="form-input form-input-small" @change="setTime($event, index, 'timeFrom', 'hours')">
                                <option
                                    :value="hour"
                                    v-for="hour in 23"
                                    :selected="getHour(day.timeFrom) == hour">
                                    {{ hour | nullerize }}
                                </option>
                            </select>
                            <span class="inline-block mx-1">:</span>
                            <select class="form-input form-input-small" @change="setTime($event, index, 'timeFrom', 'minutes')">
                                <option
                                    :value="minute"
                                    v-if="(minute % 5) == 0"
                                    v-for="(i, minute) in 60"
                                    :selected="getMinute(day.timeFrom) == minute">
                                    {{ minute | nullerize }}
                                </option>
                            </select>
                        </div>
                    </td>
                    <td>
                        <div v-if="day.timeTo">
                            <select 
                                class="form-input form-input-small"
                                @change="setTime($event, index, 'timeTo', 'hours')"
                                :disabled="day.timeOff > 0">
                                    <option
                                        :value="hour"
                                        v-for="hour in timeToRange(day)"
                                        :selected="getHour(day.timeTo) == hour">
                                        {{ hour | nullerize }}
                                    </option>
                            </select>
                            <span class="inline-block mx-1">:</span>
                            <select 
                                class="form-input form-input-small"
                                @change="setTime($event, index, 'timeTo', 'minutes')"
                                 :disabled="day.timeOff > 0">
                                    <option
                                        :value="minute"
                                        v-if="(minute % 5) == 0"
                                        v-for="(i, minute) in 60"
                                        :selected="getMinute(day.timeTo) == minute">
                                        {{ minute | nullerize }}
                                    </option>
                            </select>
                        </div>
                    </td>
                    <td>
                        <input
                            class="form-input form-input-small w-16"
                            type="number"
                            min="0"
                            v-if="showOvertime(index)"
                            v-model="marktime.marktime[index].overtime"
                            @input="setOvertime(index)">
                    </td>
                    <td class="text-center">
                        {{ getDuration(day) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
import moment from 'moment';
import { mapState } from "vuex";
import helpers from '../helpers';

var Holidays = require('date-holidays')
var hd = new Holidays('CZ')


export default {
    
    computed: {
        ...mapState({
			currentUser: state => state.user.info,
            reasons: state => state.config.reasons
        }),
        
        timeOffHoursSelect() {
            if (this.currentUser) {
                var timeOffHours = (this.currentUser.isPartTime) ? this.currentUser.partTime : 8;
                return timeOffHours
            } else return 8
        }
    },
    
    props: [
        'marktime',
        'setup'
    ],

    // watch for changes
    watch: {
        marktime: {
            deep: true,
            handler (val, oldVal) {
                this.$store.commit('SET_UNSAVED', true);
            }
        }
    },

    methods: {
        setTime(e, index, type, method) {
            var currentMarktime = this.marktime.marktime[index]
           
            var hours = 8
            var mins = 30
                

            if (this.currentUser.isPartTime) {
                hours = Math.floor(this.currentUser.partTime)
                mins = (this.currentUser.partTime % hours) * 60 + 30
            }
            
            // set the time model
            var time = currentMarktime[type]
            if (method === 'hours') time.setHours(e.target.value)
            else time.setMinutes(e.target.value)
            currentMarktime[type] = time

            if (currentMarktime.timeOff) {
                hours = hours - currentMarktime.timeOff;
                if (hours < 4) mins = 0;
            }

            if (type === 'timeFrom') {

                // if vacation is halfday
                if (currentMarktime.halfday) hours = hours / 2
                if (currentMarktime.overtime && !currentMarktime.specialHours) hours += parseFloat(currentMarktime.overtime)

                currentMarktime.timeTo = new Date(moment(currentMarktime.timeFrom).add(hours, 'h').add(mins, 'm'))
            }

            if (type === 'timeTo') {
                let timeTo = moment(currentMarktime.timeTo)
                let timeFrom = moment(currentMarktime.timeFrom)

                let duration = moment.duration(timeTo.diff(timeFrom)).asHours()

                if (currentMarktime.specialHours) hours = 0
                var breakTime = (duration > 4) ? 0.5 : 0
                let overtime = duration - breakTime - hours
                if (overtime < 1) overtime = null
                currentMarktime.overtime = overtime
            }

            // force property update (bad reactivity on arrays)
            this.$set(this.marktime.marktime, index, currentMarktime)

        },

        setReason(e, index) {
            var currentMarktime = this.marktime.marktime[index]

            // reset halfday
            currentMarktime.halfday = false

            if (e.target.value ===  '0' || e.target.value === 'SLC' || e.target.value === 'NV') {

                if (!this.isSaturday(index) && !this.isSunday(index)) {

                    var timeFrom = new Date(moment({
                        year: this.setup.year,
                        month: this.setup.month,
                        day: index + 1,
                        hour: this.currentUser.hourFrom || 8,
                        minute: this.currentUser.minFrom || 0
                    }))
    
                    currentMarktime.timeFrom = timeFrom
    
                    var hours = (this.currentUser.isPartTime) ? this.currentUser.partTime : 8
                    currentMarktime.timeTo = new Date(moment(timeFrom).add(hours + 0.5, 'h'))

                } else {
                    currentMarktime.timeTo = 0
                    currentMarktime.timeFrom = 0
                }

            }
            else {
                currentMarktime.timeTo = 0
                currentMarktime.timeFrom = 0
            }

            // reset timeoff when select again
            currentMarktime.timeOff = null;
            currentMarktime.overtime = null;

            // force property update (bad reactivity on arrays)
            this.$set(this.marktime.marktime, index, currentMarktime)
        },

        setHalfDay(index) {

            var currentMarktime = this.marktime.marktime[index]

            if (currentMarktime.halfday) {

                var timeFrom = new Date(moment({
                    year: this.setup.year,
                    month: this.setup.month,
                    day: index + 1,
                    hour: this.currentUser.hourFrom || 8,
                    minute: this.currentUser.minFrom || 0
                }))

                currentMarktime.timeFrom = timeFrom

                var hours = 8
                var mins = 30

                if (this.currentUser.isPartTime) {
                    hours = this.currentUser.partTime
                    mins = 0
                }
                hours = hours / 2
                currentMarktime.timeTo = new Date(moment(timeFrom).add(hours, 'h').add(mins, 'm'))
            }
            else {
                currentMarktime.timeTo = 0
                currentMarktime.timeFrom = 0
            }

            // force property update (bad reactivity on arrays)
            this.$set(this.marktime.marktime, index, currentMarktime)
        },

        setOvertime(index) {
            var currentMarktime = this.marktime.marktime[index]
            var timeFrom = new Date(currentMarktime.timeFrom)

            var hours = 8
            var mins = 30

            if (this.currentUser.isPartTime) {
                var floorHours = Math.floor(this.currentUser.partTime)
                hours = floorHours
                mins = (this.currentUser.partTime % floorHours) * 60 + 30
            }

            // if vacation is halfday
            if (currentMarktime.halfday) hours = hours / 2
            if (currentMarktime.specialHours) {
                hours = currentMarktime.overtime
            } else {
                hours += parseFloat(currentMarktime.overtime)
            }

            if (hours < 4) {
                mins = mins - 30
            }

            currentMarktime.timeTo = new Date(moment(timeFrom).add(hours, 'h').add(mins, 'm'))

            // force property update (bad reactivity on arrays)
            this.$set(this.marktime.marktime, index, currentMarktime)
        },

        getHour(time) {
            return new Date(time).getHours();
        },

        getMinute(time) {
            return new Date(time).getMinutes();
        },

        isSunday(day) {
            var date = moment({
                year: this.marktime.year,
                month: this.marktime.month,
                day: day + 1
            })
            return date.day() == 0;
        },

        isSaturday(day) {
            var date = moment({
                year: this.marktime.year,
                month: this.marktime.month,
                day: day + 1
            })
            return date.day() == 6;
        },

        isHoliday(day) {
            var holiday = hd.isHoliday(
                new Date(
                    moment({
                        year: this.marktime.year,
                        month: this.marktime.month,
                        day: day + 1
                    })
                )
            )

            if (holiday) {
                if (holiday.type === 'public') return true
            }

            return false
        },

        getDuration(day) {
            if (day.timeFrom) {
                return helpers.getDuration(day)
            }
            return null
        },
        
        showOvertime(day) {
            var currentMarktime = this.marktime.marktime[day]
            return (currentMarktime.type === '0' && !this.isSunday(day) && !this.isSaturday(day)) || currentMarktime.specialHours || currentMarktime.workingHoliday
        },

        setClass(index) {
            if (this.isSaturday(index)) return 'is-saturday'
            if (this.isSunday(index)) return 'is-sunday'
            if (this.isHoliday(index)) return 'is-holiday'
        },

        getDate(index, format) {
            var date = moment().set({
                'year': this.setup.year,
                'month': this.setup.month,
                'date': index + 1
            })
            return date.format(format)
        },

        setSpecialHours(index) {
            var currentMarktime = this.marktime.marktime[index]

            if (currentMarktime.specialHours) {

                var timeFrom = new Date(moment({
                    year: this.setup.year,
                    month: this.setup.month,
                    day: index + 1,
                    hour: this.currentUser.hourFrom || 8,
                    minute: this.currentUser.minFrom || 0
                }))

                currentMarktime.timeFrom = timeFrom

                var hours = 8

                if (this.currentUser.isPartTime) {
                    hours = Math.floor(this.currentUser.partTime)
                }
                currentMarktime.timeTo = new Date(moment(timeFrom).add(hours + 0.5, 'h'))
                currentMarktime.overtime = hours
            } else {
                currentMarktime.timeFrom = null
                currentMarktime.timeTo = null   
                currentMarktime.overtime = null
            }

            // force property update (bad reactivity on arrays)
            this.$set(this.marktime.marktime, index, currentMarktime)

        },

        setTimeOff(e, i) {
            
            var currentMarktime = this.marktime.marktime[i];
            var workingHours = 8;
            var startLunch = 5;
            if (this.currentUser.isPartTime) {
                workingHours = Math.floor(this.currentUser.partTime)
                startLunch = 2;
            }

            // reset
            if (!currentMarktime.timeFrom) {
                currentMarktime.timeFrom = new Date(moment(new Date()).set('h', this.currentUser.hourFrom).set('m', 0).set('s', 0));
            }
            
            var timeFrom = currentMarktime.timeFrom;
            var timeOffHours = parseFloat(e.target.value);
            var lunchHours = 0

            if (timeOffHours < startLunch) {
                lunchHours = 0.5
            }

            var diff = (this.currentUser.isPartTime) ? this.currentUser.partTime - timeOffHours : workingHours - timeOffHours;

            if (timeOffHours == workingHours) {
                currentMarktime.timeTo = null;
                currentMarktime.timeFrom = null;
            } else {
                currentMarktime.timeTo = new Date(moment(timeFrom).add(diff + lunchHours, 'h'))
            }

            // force property update (bad reactivity on arrays)
            this.$set(this.marktime.marktime, i, currentMarktime)
            
        },
        timeToRange(day) {
            var range = [];
            var fromHour = moment(day.timeFrom).hours();
            for (let i = fromHour; i < 24; i++) {
                range.push(i)
            }
            return range;
        },
        selected(index) {
            if (index == 1) return true
            return false
        },

        getReasons(index) {

            if (this.isSaturday(index) || this.isSunday(index)) {
                return this.reasons.filter(reason => reason.id === 'S' || reason.id === 'SLC')
            } else if (this.isHoliday(index)) {
                return this.reasons.filter(reason => reason.id === 'S' || reason.id === 'SLC' || reason.id === 'N')
            }

            return this.reasons;
        }
    },
    filters: {
        nullerize(hour) {
            return (hour < 10) ? '0' + hour : hour;
        }
    }
}
</script>
